
import React, { PureComponent, Fragment } from "react";
import { t, x } from "../../../helpers/localization";
import styles from "./Round.scss";
import get from "lodash/get";
import { getLeagueData, getCompetitionMetricPoints, getVersusTitle, getResult, getOwnResult } from "../../../helpers/cwars";
import settings from "../../../settings";

import { IHistoryResult, IHistoryRound, IClanInfo, ICommonInfo, IWarSettings } from "../../../Reducers/ReducerClanWars";

import { StepCSSTransitionGroup, ProgressBar } from "@wg/wows-react-uikit";

import { Result } from "../../UIKit/UIKit";

import PlayersRatingTable from "../Tabs/MyWarTab/PlayersRatingTable/PlayersRatingTable";
import VersusHeader from "../VersusHeader/VersusHeader";
import HistoryRatingTable from "../HistoryRatingTable/HistoryRatingTable";
import { ISideData } from "../VersusHeader/VersusHeader";

export type Round_IProps = {
  isVisible: boolean;
  data: IHistoryRound;
  clanInfo: IClanInfo;
  commonInfo: ICommonInfo;
  warSettings: IWarSettings;
  currentAccount: any;
};

const defaultLeague = { icons: { default: '' }, number: 0, points: [], title: '' };
const defaultShip = { name: 'myship', level: 10, shipCd: 0, isPremium: true, isSpecial: true };

class Round extends PureComponent<Round_IProps> {


  renderProgressBar = () => {
    const competitionMetric = get(this.props.data, 'stageSettings.preparation.competitionMetric', '');
    const maxClanProgress = get(this.props.data, 'stageSettings.preparation.maxClanProgress', 0);
    const maxPersonalProgress = get(this.props.data, 'stageSettings.preparation.maxPersonalProgress', 0);
    const clanProgress = get(this.props.data, 'stages.preparation.clanProgress', 0);
    const personalProgress = get(this.props.data, 'stages.preparation.personalProgress', 0);
    const clanProgressMilestones = get(this.props.data, 'stageSettings.preparation.clanProgressMilestones', []);

    return <StepCSSTransitionGroup level={1}>
                <div>
                    <div>
                        <span className={styles.preparationTitle}>{t('клан не выполнил задачу этапа подготовки')}</span>
                    </div>
                    <ProgressBar title={t('Задача клана')} target={''} mPoints={getCompetitionMetricPoints(competitionMetric)} myValue={personalProgress} myValueMax={maxPersonalProgress} totalValue={clanProgress} maxValue={maxClanProgress} breakpoints={clanProgressMilestones} competitionMetric={competitionMetric} hideTitle={true} />
                </div>
            </StepCSSTransitionGroup>;
  };

  renderVersusHeader = (result: string, myClan: ISideData, enemyClan: ISideData) => {
    return <StepCSSTransitionGroup level={1}>
                <div>
                    <div>
                        <span className={styles.roundTitle}>{getVersusTitle(result)}</span>
                    </div>
                    <VersusHeader left={myClan} right={enemyClan} withMedal={false} />
                </div>
            </StepCSSTransitionGroup>;
  };

  renderResults = (ownResults: IHistoryResult | null, result: string) => {

    if (!ownResults) {
      return null;
    }

    return <StepCSSTransitionGroup level={2}>
                <Result rating={ownResults.previousRating} ratingDelta={ownResults.ratingDelta} reward={ownResults.reward.amount} result={result} />
            </StepCSSTransitionGroup>;
  };

  renderRatingTable = () => {

    return <StepCSSTransitionGroup level={3}>
                <div className={styles.ratingTable}>
                    <div className={styles.ratingTableHeader}>
                        {t('Участники сражения')}
                    </div>
                    <HistoryRatingTable data={this.props.data.players} maxPersonalAttempts={get(this.props.warSettings, 'stages.war.maxPersonalAttempts', 0)} />
                </div>
            </StepCSSTransitionGroup>;
  };

  render() {
    if (!this.props.isVisible) {
      return null;
    }
    const failedPreparation = this.props.data.restriction === 2 || this.props.data.restriction === 3;
    const result = getResult(this.props.data.results, this.props.clanInfo.id);
    const ownResultData = getOwnResult(this.props.data.results, this.props.clanInfo.id);
    let ownData = null;
    let enemyData = get(this.props.data, 'stages.war.enemy', null);
    this.props.data.players.forEach(player => {
      if (player && player.accountId === this.props.currentAccount.id) {
        ownData = player;
      }
    });

    const myClan = {
      tag: this.props.clanInfo.tag,
      color: this.props.clanInfo.color,
      realm: settings.realm.code,
      score: get(ownResultData, 'starsCount', 0),
      leagueData: getLeagueData(this.props.warSettings.leagues, this.props.commonInfo.clan.league)
    };
    const enemyClan = {
      tag: get(enemyData, 'tag', ''),
      color: get(enemyData, 'color', ''),
      realm: get(enemyData, 'realm', '-'),
      score: get(enemyData, 'starsCount', 0),
      leagueData: defaultLeague
    };

    return <div className={styles.round}>
                {failedPreparation ? this.renderProgressBar() : this.renderVersusHeader(result, myClan, enemyClan)}
                {this.renderResults(ownResultData, result)}
                {!failedPreparation ? this.renderRatingTable() : null}
            </div>;
  }
}

export default Round;